import { ParametersService } from 'app/shared/services/parameters/parameters.service';
import { UiService } from '../../../../shared/services/ui/ui.service';
import { DatatableBaseComponent } from 'app/shared/components/datatable-base.component';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { PageEvent } from '@angular/material/paginator';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { DataService } from 'app/shared/services/data/data.service';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { Parameter } from 'app/shared/models/class/parameter/parameter';
import { OpenDialogAddEditParameterComponent } from 'app/components/dialog/open-dialog-add-edit-parameter/open-dialog-add-edit-parameter.component';

@Component({
  selector: 'app-admin-parameters-table',
  templateUrl: './admin-parameters-table.component.html',
  styleUrls: ['./admin-parameters-table.component.scss']
})
export class AdminParametersTableComponent extends DatatableBaseComponent implements OnInit {

  displayedColumns: string[] = ['label', 'type', 'values', 'isActive', 'edit'];
  dataSource: MatTableDataSource<Parameter>;


  length: number;
  pageSize = 10;
  pageSizeOptions: number[] = [10, 25, 50];
  pageEvent: PageEvent;

  color: ThemePalette = 'primary';
  userConnected: any;

  isLoading = false;

  constructor(
    private dialog: MatDialog,
    private parametersSrv: ParametersService,
    private dataService: DataService,
    private authService: AuthService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private faIconService: FaiconService,
    protected uiSrv: UiService
  ) {
    super(uiSrv);
  }

  ngOnInit(): void {
    this.initComponent();
    this.initSub();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  addOrEditParameter(action: string, parameter?: Parameter): void {

    const dialogRef = this.dialog.open(OpenDialogAddEditParameterComponent, {
      data: { action, parameter },
      width: '50%',
      maxHeight: '80%'
    });

    dialogRef.afterClosed().subscribe(res => {

      if (res) {
        this.dataService.clubActiveParameters$.next(res.data);
        this.getParameters();
        this.uiSrv.showSnackbar('Paramètre modifié avec succès');
      }

    });
  }

  private async initComponent() {
    this.getParameters();
  }

  private getParameters() {
    this.isLoading = true;
    this.parametersSrv.getParameters().subscribe({
      next: parameters => {
        this.dataSource = new MatTableDataSource<any>(parameters);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.length = parameters.length;
        this.dataService.updatedParameters$.next(false);
        this.isLoading = false;
      }
    });
  }

  private initSub(): void {
    this.addSubscription(
      this.dataService.valueFilterParameter$.subscribe({
        next: valueFilterParameter => {
          this.applyFilter(valueFilterParameter);
          this.cdr.detectChanges();
        }
      })
    );

    this.addSubscription(
      this.dataService.updatedParameters$.subscribe({
        next: update => {
          if (update) {
            this.getParameters();
          }
        }
      })
    );
  }

  applyFilter(filterValue: string): void {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  getValues(type: string, values: any): string {
    let valueConvert = null;
    const valuesSplit = values.split('#');
    switch (type) {
      case 'valeur min/max':
        valueConvert = [
          {
            name: 'Min:',
            value: valuesSplit[0]
          },
          {
            name: 'Max:',
            value: valuesSplit[1]
          },
        ];
        break;

      case 'liste':
        valueConvert = [];
        valuesSplit.forEach((v, index) => {
          const value = {
            name: ``,
            value: v
          };
          valueConvert.push(value);
        });

        break;

      case 'checkbox':
        valueConvert = [];
        valuesSplit.forEach((v, index) => {
          const value = {
            name: `Case ${index+1}:`,
            value: v
          };
          valueConvert.push(value);
        });
        break;

      default:
        valueConvert = [];
        break;

    }

      let string = '';
      valueConvert.map((object, index) => {
        if (index > 0) {
          string += ', '
        }
        string += object.name + ' ' + object.value;

      })

      return string;
  }

  activateDesactivate(element, value) {
    this.parametersSrv.activateDesactivateParameter(element, value).subscribe(() => {
      element.isActive = value;
      this.uiSrv.showSnackbar(value ? 'Paramètre activé avec succès': 'Paramètre désactivé avec succès');
    })
  }

}
